import React, { useLayoutEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import ContactUs from "../../components/Form/ContactUs/index.js";
import { About } from "../../components/About/About";
import { Enter } from "../../components/Enter/Enter";
import { Footer } from "../../components/Footer/Footer";
import { Posts } from "../../components/Posts/Posts";
import { Support } from "../../components/Support/Support";
//import { Welcome } from "../../components/Welcome/Welcome";
import { Welcome } from "../../components/NewWelcome/Welcome.js";
import { StyledLanding } from "./styles";

export const Landing = ({ year, elementId }) => {
  const [circleAnimation, setCircleAnimation] = useState(false);
  const [supportAni, setSupportAni] = useState(false);
  const [aboutAni, setAboutAni] = useState(false);
  const [luckAni, setLuckAni] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const toggleForm = () => setShowForm(!showForm);

  useLayoutEffect(() => {
    if (elementId === "mytruehome") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (window.innerWidth < 600 && elementId === "swmc") {
      let scrollToElement = document.getElementById(elementId);
      window.scrollTo({
        top: scrollToElement.offsetTop + 200,
        behavior: "smooth",
      });
    } else {
      let scrollToElement = document.getElementById(elementId);
      window.scrollTo({
        top: scrollToElement.offsetTop - 60,
        behavior: "smooth",
      });
    }
  }, [elementId]);

  useLayoutEffect(() => {
    onLoad();
  }, []);
  useLayoutEffect(() => {
    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onLoad = () => {
    const docViewTop = window.scrollY;
    const docViewBottom = docViewTop + window.innerHeight;
    const circle = document.querySelector(".encircled");
    const support = document.querySelector("#taca");
    const about = document.querySelector("#swmc");
    const luck = document.querySelector("#luck");
    if (circle.offsetTop <= docViewBottom && circle.offsetTop >= docViewTop) {
      setCircleAnimation(true);
    }
    if (support.offsetTop <= docViewBottom && support.offsetTop >= docViewTop) {
      setSupportAni(true);
    }

    if (about.offsetTop <= docViewBottom && about.offsetTop >= docViewTop) {
      setAboutAni(true);
    }
    if (
      luck.offsetTop <= docViewTop + window.innerHeight / 1.5 &&
      luck.offsetTop >= docViewTop
    ) {
      setLuckAni(true);
    }
  };

  const onScroll = () => {
    const docViewTop = window.scrollY;
    const docViewBottom = docViewTop + window.innerHeight;
    const circle = document.querySelector(".encircled");
    const support = document.querySelector("#taca");
    const about = document.querySelector("#swmc");
    const luck = document.querySelector("#luck");

    if (circle.offsetTop <= docViewBottom && circle.offsetTop >= docViewTop) {
      setCircleAnimation(true);
    }

    if (support.offsetTop <= docViewBottom && support.offsetTop >= docViewTop) {
      setSupportAni(true);
    }

    if (about.offsetTop <= docViewBottom && about.offsetTop >= docViewTop) {
      setAboutAni(true);
    }
    if (
      luck.offsetTop <= docViewTop + window.innerHeight / 1.5 &&
      luck.offsetTop >= docViewTop
    ) {
      setLuckAni(true);
    }
  };

  return (
    <StyledLanding id="mytruehome">
      <Modal size="lg" className="mt-1"
        show={showForm}
        onHide={toggleForm}
        keyboard={false}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <ContactUs />
        </Modal.Body>
      </Modal>
      {/* <Welcome toggleForm={toggleForm} /> */}
      <Welcome toggleForm={toggleForm} />
      <Enter circleAnimation={circleAnimation} />
      <Support supportAni={supportAni} />
      <About aboutAni={aboutAni} />
      <ContactUs toggleForm={toggleForm}  />
      <Footer year={year} luckAni={luckAni} />
    </StyledLanding>
  );
};
